export default "__VITE_ASSET__C9P5s1WJ__";